export const USER_PROFILE_CACHE_TTL = 4 * 60 * 60 * 1000;
// This only controls the immediate/offline fallback. Once the four-hour fresh
// TTL expires, Firestore is still queried in the background on the next visit.
export const USER_PROFILE_STALE_TTL = 30 * 24 * 60 * 60 * 1000;

export const USER_PROFILE_CACHE_OPTIONS = Object.freeze({
  ttl: USER_PROFILE_CACHE_TTL,
  staleTtl: USER_PROFILE_STALE_TTL,
  staleWhileRevalidate: true
});

export const getUserProfileCacheKey = (userId: string|null|undefined) =>
  `user_profile_${String(userId || "")}`;
